import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Modal,
  Radio,
  Button,
  message,
  Icon,
  Spin,
  Tooltip,
  Popconfirm,
  Form,
  Input,
  Upload
} from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import { actions } from '../../../redux/modules/jobFunctions/jobSiteChangeOrderActions'
import { actions as jobSiteRepairOrderActions } from '../../../redux/modules/jobFunctions/jobSiteRepairOrderActions'
import { actions as jobSiteEstimateActions } from '../../../redux/modules/jobFunctions/jobSiteEstimateActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import Loader from '../../common/Loader'
import ChangeOrderEditor from '../../../components/ChangeOrderEditor'
import { filterCaseInsensitive, arrayMove, getModalId } from '../../../util'
import config from '../../../config'
import _ from 'lodash'
import history from '../../../history'

const { API_BASE } = config
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { TextArea } = Input
const MarginBottom = styled.div`
  margin-bottom: 10px;
  margin-top: 10px;
`
const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`
const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const propTypes = {}

class JobSiteChangeOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      changeOrderItems: null,
      changeOrderItemsChanged: false,
      estimateGrandTotal: 0,
      currentRevisionNumberPrint: 1,
      path: this.props.title === 'Job Site Repair Orders' ? 'repair-orders' : 'change-orders'
    }

    if (this.props.title === 'Job Site Repair Orders') {
      // get repair order templates
      this.props.fetchRepairOrderTemplates()
    }

    if (this.props.title === 'Job Site Change Orders') {
      // get repair order templates
      this.props.fetchChangeOrderTemplates()
    }

    this.props.jobSiteChangeOrdersRefresh({
      jobId: this.props.jobId,
      next: (payload, err) => {
        const changeOrderId = getModalId(this.props.location.pathname)
        if (changeOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(changeOrderId, 10) })
            if (current) {
              setTimeout(() => this.handleRowClick(current), 500)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
    this.props.jobSiteEstimatesRefresh({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps, nextState) {
    if (
      this.props.shortcutItemId &&
      this.props.jobSiteChangeOrderActions.jobSiteChangeOrders !==
        prevProps.jobSiteChangeOrderActions.jobSiteChangeOrders
    ) {
      const highLightChangeOrder = _.filter(
        this.props.jobSiteChangeOrderActions.jobSiteChangeOrders &&
          this.props.jobSiteChangeOrderActions.jobSiteChangeOrders.data,
        changeOrder => changeOrder.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highLightChangeOrder[0])
      this.props.clearHighlight()
    }

    // update the current version for printing
    if (prevProps.auditActions.loading !== this.props.auditActions.loading) {
      const revisions = _.get(this.props, 'auditActions.revisions.data')
      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].revision
        })
      }
    }
  }

  handleRowClick = row => {
    const { title } = this.props

    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'change_order'
    })
    this.props.getAttachmentsChangeOrder({
      changeOrderId: row.id
    })

    var selectedTemplate
    if (title === 'Job Site Repair Orders') {
      const repairOrderTemplates = _.get(
        this.props,
        'jobSiteRepairOrderActions.repairOrderTemplates.data'
      )

      selectedTemplate = repairOrderTemplates.find(
        repairOrderTemplate =>
          parseInt(repairOrderTemplate.id, 0) === parseInt(row.change_order_template_id, 0)
      )
    } else {
      const changeOrderTemplates = _.get(
        this.props,
        'jobSiteChangeOrderActions.changeOrderTemplates.data'
      )

      selectedTemplate = changeOrderTemplates.find(
        changeOrderTemaplate =>
          parseInt(changeOrderTemaplate.id, 0) === parseInt(row.change_order_template_id, 0)
      )
    }
    this.setState({
      currentId: row.id,
      contentData: row,
      estimateName: row.estimate_name,
      estimateGrandTotal: row.grand_total,
      changeOrderStatus: row.status,
      changeOrderNumber: row.number,
      changeOrderItems: row.items,
      selectedTemplate: selectedTemplate,
      estimateId: row.estimate_id,
      scopeOfWork: row.scope_of_work,
      schedule: row.schedule,
      payment_schedule: row.payment_schedule
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/${this.state.path}/modal/${row.id}`)
    this.props.getChangeOrderItems(row.id)
    this.props.getEstimateItems(row.estimate_id)
  }

  handleAddButton = () => {
    this.props.resetEstimateItems()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/${this.state.path}/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null,
      estimateName: null,
      selectedTemplate: null,
      estimateGrandTotal: 0,
      changeOrderItems: []
    })
  }

  handleCancel = () => {
    this.props.jobSiteChangeOrdersRefresh({
      jobId: this.props.jobId
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/${this.state.path}`)
    this.setState({
      currentId: 0,
      contentData: null,
      changeOrderItems: null,
      estimateGrandTotal: 0,
      estimateName: null,
      selectedTemplate: null
    })
  }

  setChangeOrderItems = items => {
    this.setState({
      changeOrderItems: items
    })
  }

  setSelectedTemplate = template => {
    this.setState({
      selectedTemplate: template
    })
  }

  handleCreate = () => {
    if (this.state.currentId === 0) {
      this.props.createJobSiteChangeOrder({
        jobId: this.props.jobId,
        changeOrderItems: this.state.changeOrderItems,
        estimateId: this.state.estimateId,
        grandTotal: this.state.estimateGrandTotal,
        description: this.state.estimateDescription,
        selectedTemplate: this.state.selectedTemplate,
        scopeOfWork: this.state.scopeOfWork,
        schedule: this.state.schedule,
        payment_schedule: this.state.payment_schedule
      })
    } else {
      this.props.updateJobSiteChangeOrder({
        changeOrderId: this.state.currentId,
        jobId: this.props.jobId,
        changeOrderItems: this.state.changeOrderItems,
        estimateId: this.state.estimateId,
        grandTotal: this.state.estimateGrandTotal,
        status: this.state.changeOrderStatus,
        number: this.state.changeOrderNumber,
        selectedTemplate: this.state.selectedTemplate,
        scopeOfWork: this.state.scopeOfWork,
        schedule: this.state.schedule,
        payment_schedule: this.state.payment_schedule
      })
    }

    message.success('Changes saved.')
    this.props.resetEstimateItems()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/${this.state.path}`)
    this.setState({
      contentData: null,
      currentId: 0,
      selectedTemplate: null,
      changeOrderItems: null,
      estimateName: null
    })
  }

  confirmDelete = event => {
    this.props.deleteChangeOrder({
      jobId: this.props.jobId,
      changeOrderId: this.state.currentId
    })

    message.success('Record deleted.')
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/${this.state.path}`)
    this.setState({
      contentData: null,
      currentId: 0
    })
  }

  handleScopeOfWorkChange = e => {
    this.setState({
      scopeOfWork: e.target.value
    })
  }

  handleScheduleChange = e => {
    this.setState({
      schedule: e.target.value
    })
  }

  handlePaymentScheduleChange = e => {
    this.setState({
      payment_schedule: e.target.value
    })
  }

  handleChangeOrderItemsChange = changeOrderItems => {
    this.setState({
      changeOrderItems
    })
  }

  handleChangeOrderInputChange = (value, key, column) => {
    const groupedItems = this.state.changeOrderItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      changeOrderItems: groupedItems
    })
  }

  editChangeOrderRow = rowId => {
    const groupedItems = this.state.changeOrderItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      changeOrderItems: groupedItems
    })
  }

  saveChangeOrderRow = rowId => {
    const groupedItems = this.state.changeOrderItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      changeOrderItems: groupedItems
    })
  }

  deleteChangeOrderRow = rowId => {
    const groupedItems = this.state.changeOrderItems.filter(item => item.id !== rowId)

    this.setState({
      changeOrderItems: groupedItems
    })
  }

  handleAddChangeOrderItemInputChange = itemId => {
    const estimateItems = _.get(this.props, 'jobSiteEstimateActions.jobSiteEstimateItems')
    const estimateItem = _.find(estimateItems, item => parseInt(item.id, 10) === itemId)

    this.setState({
      estimateSelectedItem: estimateItem
    })
  }

  handleAddChangeOrderDescriptionInputChange = value => {
    this.setState({
      addDescriptionInput: value
    })
  }

  handleAddChangeOrderTypeInputChange = value => {
    this.setState({
      addTypeInput: value
    })
  }

  handleAddChangeOrderItemClick = () => {
    const groupedItems = this.state.changeOrderItems || []
    const lastId = groupedItems[groupedItems.length - 1]
      ? groupedItems[groupedItems.length - 1].id
      : 1

    const item = Object.assign(
      { ...this.state.estimateSelectedItem },
      {
        type: this.state.addTypeInput,
        description: this.state.addDescriptionInput,
        id: lastId + 1
      }
    )

    groupedItems.push(item)
    this.setState({
      estimateSelectedItem: null,
      changeOrderItems: groupedItems,
      addDescriptionInput: '',
      addTypeInput: ''
    })
  }

  handleChangeOrderItemsChange = changeOrderItems => {
    this.setState({
      toSendChangeOrders: changeOrderItems
    })
  }

  handleEstimateChange = value => {
    const selectedEstimate = this.props.jobSiteEstimateActions.jobSiteEstimates.data.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )

    if (selectedEstimate.length > 0) {
      this.setState({
        estimateId: selectedEstimate[0].id,
        estimateName: selectedEstimate[0].estimate_template_name,
        estimateGrandTotal: selectedEstimate[0].grand_total,
        estimateDescription: selectedEstimate[0].description
      })
      this.props.getEstimateItems(selectedEstimate[0].id)
    }
  }

  getEstimateDescription = id => {
    if (
      this.props.jobSiteEstimateActions.jobSiteEstimates &&
      this.props.jobSiteEstimateActions.jobSiteEstimates.data
    ) {
      const filteredEstimate = this.props.jobSiteEstimateActions.jobSiteEstimates.data.filter(
        estimate => estimate.id === id
      )
      return filteredEstimate.length > 0 ? filteredEstimate[0].description : ''
    } else {
      return ''
    }
  }

  moveItemUp = id => {
    let items = []
    this.state.changeOrderItems.forEach((item, index) => {
      if (item.id === id) {
        items = arrayMove(this.state.changeOrderItems, index, index - 1)
      }
    })
    this.setState({ changeOrderItems: items })
  }

  moveItemDown = id => {
    let items = []
    this.state.changeOrderItems.some((item, index) => {
      if (item.id === id) {
        items = arrayMove(this.state.changeOrderItems, index, index + 1)
        return true
      }
    })
    this.setState({ changeOrderItems: items })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'payment_request')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('changeOrderId', this.state.currentId)

    this.props.uploadAttachmentChangeOrder({
      formData: formData,
      changeOrderId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescriptionChangeOrder({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      changeOrderId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachmentChangeOrder({
      attachmentId: this.state.attachmentId,
      changeOrderId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleStatusChange = event => {
    this.setState({ changeOrderStatus: event.target.value })
  }

  handleRevisionChange = value => {
    const form = this.props.form
    const revisionsArrray = _.get(this.props, 'auditActions.revisions.data')
    const revisionObject = revisionsArrray.find(x => x.id === value)
    const revisions = JSON.parse(revisionObject.json_patch)

    // set revision for printing
    this.setState({
      currentRevisionNumberPrint: revisionObject.revision
    })

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)

      if (fieldName === 'change_order_items') {
        this.setState(prevState => {
          const changeOrderItems = JSON.parse(revision.value)
          return { ...prevState, changeOrderItems }
        })
      }

      if (fieldName === 'status') {
        this.setState(prevState => {
          return { ...prevState, changeOrderStatus: revision.value }
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        changes[fieldName] = Number.isInteger(revision.value) ? +revision.value : revision.value
      }
    })

    form.setFieldsValue(changes)
  }

  onBlurGrandTotal = e => {
    const { value } = e.target
    this.setState({
      estimateGrandTotal: value.replace(/\$\s?|(,*)/g, '')
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const { contentData, changeOrderItems, currentRevisionNumberPrint } = this.state
    const { title, jobId } = this.props
    const { jobType } = this.props.match.params

    const uploadProps = {
      multiple: true,
      showUploadList: false
    }

    if (!this.props.jobSiteChangeOrderActions.jobSiteChangeOrders) {
      return <Loader />
    }

    const revisions = _.get(this.props, 'auditActions.revisions.data')
    const loadingRevision = _.get(this.props, 'auditActions.loading')
    const repairOrderTemplates = _.get(
      this.props,
      'jobSiteRepairOrderActions.repairOrderTemplates.data'
    )
    const changeOrderTemplates = _.get(
      this.props,
      'jobSiteChangeOrderActions.changeOrderTemplates.data'
    )

    const estimateItems = _.get(this.props, 'jobSiteEstimateActions.jobSiteEstimateItems')
    const loadingEstimateItems = _.get(this.props, 'jobSiteEstimateActions.loading')

    const isRepairOrder = this.props.title === 'Job Site Repair Orders'

    return (
      <div>
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title={title}
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={1020}
            maskClosable={false}
          >
            {contentData && (
              <MarginBottom>
                <div className="row">
                  <div className="col-md-6">
                    {loadingRevision ? (
                      <Spin size="small" className="marginLeft5" />
                    ) : (
                      <a
                        href={`${API_BASE}/api/job/job_site_change_orders/print/${
                          contentData.id
                        }?revision=${currentRevisionNumberPrint}&type=${
                          isRepairOrder ? 'repair' : 'change'
                        }`}
                        target="_blank"
                      >
                        <Button icon="printer" className="marginLeft5" />
                      </a>
                    )}
                  </div>
                  <div className="col-md-6 text-right">
                    <RadioGroup
                      value={this.state.changeOrderStatus}
                      defaultValue={this.state.contentData.status}
                      onChange={this.handleStatusChange}
                    >
                      <RadioButton value="open">Open</RadioButton>
                      <RadioButton value="signed">Signed</RadioButton>
                      <RadioButton value="rejected">Rejected</RadioButton>
                    </RadioGroup>
                  </div>
                </div>
              </MarginBottom>
            )}
            <ChangeOrderEditor
              changeOrderItems={changeOrderItems}
              handleChangeOrderItemsChange={this.handleChangeOrderItemsChange}
              estimateGrandTotal={this.state.estimateGrandTotal}
              editRow={this.editChangeOrderRow}
              saveRow={this.saveChangeOrderRow}
              deleteRow={this.deleteChangeOrderRow}
              handleAddItemInputChange={this.handleAddChangeOrderItemInputChange}
              handleAddDescriptionInputChange={this.handleAddChangeOrderDescriptionInputChange}
              handleAddTypeInputChange={this.handleAddChangeOrderTypeInputChange}
              handleAddItemClick={this.handleAddChangeOrderItemClick}
              handleInputChange={this.handleChangeOrderInputChange}
              estimateSelectedItem={this.state.estimateSelectedItem}
              addDescriptionInput={this.state.addDescriptionInput}
              addTypeInput={this.state.addTypeInput}
              nextStep={() => this.nextStep()}
              prevStep={() => this.prevStep()}
              handleEstimateChange={this.handleEstimateChange}
              estimateList={
                this.props.jobSiteEstimateActions &&
                this.props.jobSiteEstimateActions.jobSiteEstimates &&
                this.props.jobSiteEstimateActions.jobSiteEstimates.data
              }
              estimateName={this.state.estimateName}
              moveItemUp={this.moveItemUp}
              moveItemDown={this.moveItemDown}
              revisions={revisions}
              loadingRevision={loadingRevision}
              handleRevisionChange={this.handleRevisionChange}
              isEditing={Boolean(contentData)}
              title={title}
              isRepairOrder={isRepairOrder}
              repairOrderTemplates={repairOrderTemplates}
              changeOrderTemplates={changeOrderTemplates}
              setChangeOrderItems={this.setChangeOrderItems}
              setSelectedTemplate={this.setSelectedTemplate}
              selectedTemplate={this.state.selectedTemplate}
              tempalteId={this.state.tempalteId}
              estimateItems={estimateItems}
              loadingEstimateItems={loadingEstimateItems}
              modalVisible={this.state.modalVisible}
              onBlurGrandTotal={this.onBlurGrandTotal}
              handleScopeOfWorkChange={this.handleScopeOfWorkChange}
              handleScheduleChange={this.handleScheduleChange}
              handlePaymentScheduleChange={this.handlePaymentScheduleChange}
              schedule={this.state.schedule}
              scopeOfWork={this.state.scopeOfWork}
              payment_schedule={this.state.payment_schedule}
            />
            {contentData && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h5>
                      <Icon type="check" /> {`${title} Files`}
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    {this.props.jobSiteChangeOrderActions &&
                      this.props.jobSiteChangeOrderActions.uploadingAttachment && (
                        <div className="text-success">
                          <Icon type="loading" /> Uploading File(s)
                        </div>
                      )}
                    {this.props.jobSiteChangeOrderActions &&
                      this.props.jobSiteChangeOrderActions.deletingAttachment && (
                        <div className="text-danger">
                          <Icon type="loading" /> Deleting File(s)
                        </div>
                      )}
                  </div>
                </div>
                {this.props.jobSiteChangeOrderActions.jobChangeOrderAttachments &&
                  this.props.jobSiteChangeOrderActions.jobChangeOrderAttachments.data.length >
                    0 && (
                    <Spin spinning={this.props.jobSiteChangeOrderActions.loadingAttachments}>
                      <ReactTable
                        defaultPageSize={5}
                        data={this.props.jobSiteChangeOrderActions.jobChangeOrderAttachments.data}
                        defaultFilterMethod={filterCaseInsensitive}
                        getTrProps={(state, rowInfo, column, instance) => ({
                          onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                        })}
                        columns={[
                          {
                            Header: 'Attached Files',
                            columns: [
                              {
                                Header: 'Filename',
                                id: 'filename',
                                accessor: 'filename',
                                Cell: d => (
                                  <Tooltip title={d.original.filename}>
                                    {d.original.filename}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Description',
                                id: 'description',
                                accessor: 'description',
                                Cell: d => (
                                  <Tooltip title={d.original.description}>
                                    {d.original.description}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Created By',
                                id: 'created_by',
                                accessor: 'created_by',
                                Cell: d => (
                                  <Tooltip
                                    title={`${d.original.created_by_first_name} ${
                                      d.original.created_by_last_name
                                    }`}
                                  >
                                    {`${d.original.created_by_first_name} ${
                                      d.original.created_by_last_name
                                    }`}
                                  </Tooltip>
                                )
                              },
                              {
                                Cell: row => (
                                  <Tooltip placement="left" title="Open this file on a new window">
                                    <a target="_blank" href={row.original.signedUrl}>
                                      <Icon type="export" className="fontSize20" />
                                    </a>
                                  </Tooltip>
                                ),
                                maxWidth: 35
                              }
                            ]
                          }
                        ]}
                        defaultSorted={[
                          {
                            id: 'id',
                            desc: true
                          }
                        ]}
                        className="-striped -highlight"
                      />
                    </Spin>
                  )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> OK
                      </Button>{' '}
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2">
                          {' '}
                          DELETE
                        </Button>
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload ${title} File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
          </Modal>
        )}
        <div className="jobsBar">
          {`${title}s`}
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              {`CREATE ${title}`}
            </div>
          </div>
        </div>
        {this.props.jobSiteChangeOrderActions.jobSiteChangeOrders && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header === 'Estimate ID') {
                  return false
                } else {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.jobSiteChangeOrderActions.jobSiteChangeOrders.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 90
                  },
                  {
                    Header: 'Estimate ID',
                    id: 'estimate_id',
                    accessor: d => (
                      <Link
                        to={`/jobView/${jobId}/${jobType}/site-estimates/modal/${d.estimate_id}`}
                      >
                        {d.estimate_id}
                      </Link>
                    ),
                    maxWidth: 150,
                    filterable: false
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={this.getEstimateDescription(d.original.estimate_id)}>
                        {this.getEstimateDescription(d.original.estimate_id)}
                      </Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200,
                    filterable: false
                  },
                  {
                    Header: 'Grand Total',
                    accessor: 'grand_total',
                    Cell: row => <div>{numeral(row.original.grand_total).format('$0,0.00')}</div>,
                    maxWidth: 150,
                    filterable: false
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  { jobSiteChangeOrderActions, jobSiteEstimateActions, auditActions, jobSiteRepairOrderActions },
  ownProps
) => ({
  jobSiteChangeOrderActions,
  jobSiteEstimateActions,
  auditActions,
  jobSiteRepairOrderActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, actions, jobSiteEstimateActions, auditActions, jobSiteRepairOrderActions),
    dispatch
  )
})

JobSiteChangeOrders.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteChangeOrders))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteChangeOrders.js